/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * VitalMetric
 * The measurements a threshold can be set on.
 *
 * These are columns on ``visits``; there is no separate measurement table, and
 * a breach is derived from the visit rather than recorded beside it.
 */
export enum VitalMetric {
  BLOOD_PRESSURE_SYSTOLIC = 'BLOOD_PRESSURE_SYSTOLIC',
  BLOOD_PRESSURE_DIASTOLIC = 'BLOOD_PRESSURE_DIASTOLIC',
  HEART_RATE = 'HEART_RATE',
  BLOOD_GLUCOSE = 'BLOOD_GLUCOSE',
  TEMPERATURE = 'TEMPERATURE',
}

/** Doctor */
export interface Doctor {
  /** Doctorid */
  doctorId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phoneoffice */
  phoneOffice?: string | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Specialization */
  specialization?: string | null;
  /** Licensenumber */
  licenseNumber?: string | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
  /** Userid */
  userId?: number | null;
  /**
   * Commissionrate
   * Commission percentage (0-100%). Default is 10%
   * @min 0
   * @max 100
   * @default 10
   */
  commissionRate?: number;
}

/** DoctorCreate */
export interface DoctorCreate {
  /**
   * Firstname
   * Doctor's first name
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * Doctor's last name
   * @minLength 1
   */
  lastName: string;
  /**
   * Email
   * A valid email address for the doctor
   * @format email
   */
  email: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phoneoffice */
  phoneOffice?: string | null;
  /**
   * Street
   * Street address of the doctor
   */
  street?: string | null;
  /**
   * City
   * City where the doctor is located
   */
  city: string;
  /**
   * Postalcode
   * Postal code of the doctor's address
   */
  postalCode?: string | null;
  /**
   * Geolat
   * Latitude of the doctor's address
   */
  geoLat?: number | null;
  /**
   * Geolng
   * Longitude of the doctor's address
   */
  geoLng?: number | null;
  /** Specialization */
  specialization?: string | null;
  /** Licensenumber */
  licenseNumber?: string | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
  /**
   * Userid
   * Associated user ID, if applicable
   */
  userId?: number | null;
  /**
   * Commissionrate
   * Commission percentage (0-100%). Default is 10%
   * @min 0
   * @max 100
   * @default 10
   */
  commissionRate?: number;
}

/** DoctorGetAllPaginationResponse */
export interface DoctorGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: Doctor[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * DoctorPatient
 * One of the doctor's patients, with just enough to render the list.
 *
 * One row per PATIENT, not per link. A client may hold several
 * ``client_doctors`` rows to the same doctor - one per ``doctor_type``, one per
 * commission variant - so ``is_active`` is true while ANY of them is live, and
 * ``end_date`` is the day the relationship ended, which exists only once they
 * are all closed.
 */
export interface DoctorPatient {
  /** Clientid */
  clientId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Doctortype */
  doctorType: string;
  /**
   * Startdate
   * @format date
   */
  startDate: string;
  /** Enddate */
  endDate?: string | null;
  /** Isactive */
  isActive: boolean;
  /** Lastvisitat */
  lastVisitAt?: string | null;
  /** Nextvisitat */
  nextVisitAt?: string | null;
  /**
   * Completedvisits
   * @default 0
   */
  completedVisits?: number;
  /**
   * Scheduledvisits
   * @default 0
   */
  scheduledVisits?: number;
}

/** DoctorThreshold */
export interface DoctorThreshold {
  /** Thresholdid */
  thresholdId?: number | null;
  /** Doctorid */
  doctorId: number;
  /**
   * The measurements a threshold can be set on.
   *
   * These are columns on ``visits``; there is no separate measurement table, and
   * a breach is derived from the visit rather than recorded beside it.
   */
  metric: VitalMetric;
  /** Lowvalue */
  lowValue?: string | null;
  /** Highvalue */
  highValue?: string | null;
  /**
   * Isenabled
   * @default true
   */
  isEnabled?: boolean;
  /**
   * Isdefault
   * @default false
   */
  isDefault?: boolean;
}

/** DoctorThresholdUpsert */
export interface DoctorThresholdUpsert {
  /**
   * The measurements a threshold can be set on.
   *
   * These are columns on ``visits``; there is no separate measurement table, and
   * a breach is derived from the visit rather than recorded beside it.
   */
  metric: VitalMetric;
  /** Lowvalue */
  lowValue?: number | string | null;
  /** Highvalue */
  highValue?: number | string | null;
  /**
   * Isenabled
   * @default true
   */
  isEnabled?: boolean;
}

/** DoctorUpdate */
export interface DoctorUpdate {
  /**
   * Firstname
   * Doctor's first name
   */
  firstName?: string | null;
  /**
   * Lastname
   * Doctor's last name
   */
  lastName?: string | null;
  /** Email */
  email?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phoneoffice */
  phoneOffice?: string | null;
  /**
   * Street
   * Street address of the doctor
   */
  street?: string | null;
  /**
   * City
   * City where the doctor is located
   */
  city?: string | null;
  /**
   * Postalcode
   * Postal code of the doctor's address
   */
  postalCode?: string | null;
  /**
   * Geolat
   * Latitude of the doctor's address
   */
  geoLat?: number | null;
  /**
   * Geolng
   * Longitude of the doctor's address
   */
  geoLng?: number | null;
  /** Specialization */
  specialization?: string | null;
  /** Licensenumber */
  licenseNumber?: string | null;
  /** Isactive */
  isActive?: boolean | null;
  /**
   * Commissionrate
   * Commission percentage (0-100%). Default is 10%
   */
  commissionRate?: number | null;
  /**
   * Userid
   * Associated user ID, if applicable
   */
  userId?: number | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** PaginatedResponse[DoctorPatient] */
export interface PaginatedResponseDoctorPatient {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: DoctorPatient[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ThresholdBreach
 * A measurement outside the doctor's bounds, derived at read time.
 *
 * Not stored: the value lives on the visit already, and a second copy would be
 * free to drift from it and to survive a correction to the original.
 */
export interface ThresholdBreach {
  /** Visitid */
  visitId: number;
  /** Clientid */
  clientId: number;
  /** Clientfirstname */
  clientFirstName?: string | null;
  /** Clientlastname */
  clientLastName?: string | null;
  /**
   * The measurements a threshold can be set on.
   *
   * These are columns on ``visits``; there is no separate measurement table, and
   * a breach is derived from the visit rather than recorded beside it.
   */
  metric: VitalMetric;
  /** Value */
  value: string;
  /** Limitvalue */
  limitValue: string;
  /**
   * Side
   * 'high' or 'low'
   */
  side: string;
  /**
   * Measuredat
   * @format date-time
   */
  measuredAt: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/doctors-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title doctors
 * @version 1.0.0
 * @baseUrl /api/v1/doctors-api/
 *
 *
 * Microservice for managing home care doctors.
 *
 * ## Features
 * * Create, read, update, and delete doctors
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name HealthCheckHealthGet
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    healthCheckHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  doctor = {
    /**
     * @description Resolves the account's `doctorId` attribute to the doctor row. A 404 here means the account holds the doctor role but is linked to no doctor record - which is worth reporting rather than rendering a portal around an identity that is not there.
     *
     * @tags Doctor portal
     * @name GetMyDoctorRecord
     * @summary The signed-in doctor's own record
     * @request GET:/doctor/me
     * @secure
     */
    getMyDoctorRecord: (params: RequestParams = {}) =>
      this.request<Doctor, void>({
        path: `/doctor/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Clients with a `client_doctors` link to this doctor, either as attending or referring, with their visit counts and the dates of the last completed and next scheduled visit. One row per PATIENT, not per link: a client legitimately has several links to the same doctor - one per type, one per commission variant - so `isActive` is true while ANY of them is live and `endDate` is the day the last one closed, set only once they all have. By default only active patients. `include_ended` adds the ones whose relationship is over; their visit counts stay scoped to the period the doctor was actually involved, so an ended patient reports what happened on their watch and nothing after it.
     *
     * @tags Doctor portal
     * @name ListMyPatients
     * @summary The doctor's own patients
     * @request GET:/doctor/patients
     * @secure
     */
    listMyPatients: (
      query?: {
        /**
         * Include Ended
         * Also list patients whose relationship has ended
         * @default false
         */
        include_ended?: boolean;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseDoctorPatient, HTTPValidationError>({
        path: `/doctor/patients`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Always returns all five metrics. One the doctor has never set is reported at its clinical default with `isDefault` true, rather than omitted - an omitted metric renders as a blank control, which reads as 'not alerting' when the opposite is true.
     *
     * @tags Doctor portal
     * @name ListMyThresholds
     * @summary The doctor's alerting bounds
     * @request GET:/doctor/thresholds
     * @secure
     */
    listMyThresholds: (params: RequestParams = {}) =>
      this.request<DoctorThreshold[], any>({
        path: `/doctor/thresholds`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upserts a single metric. These affect only this doctor's own alerting; they do not change the care plan, and no other role reads them.
     *
     * @tags Doctor portal
     * @name UpsertMyThreshold
     * @summary Set one of your own bounds
     * @request PUT:/doctor/thresholds
     * @secure
     */
    upsertMyThreshold: (data: DoctorThresholdUpsert, params: RequestParams = {}) =>
      this.request<DoctorThreshold, HTTPValidationError>({
        path: `/doctor/thresholds`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Derived at read time from the vitals already recorded on visits - nothing is stored. Raising a bound clears the corresponding breaches immediately, and correcting a mistyped measurement corrects the alert, because there is only ever one copy of the value. Scoped to the doctor's own patients by row-level security, not by this query.
     *
     * @tags Doctor portal
     * @name ListMyThresholdBreaches
     * @summary Measurements outside the doctor's bounds
     * @request GET:/doctor/threshold-breaches
     * @secure
     */
    listMyThresholdBreaches: (
      query?: {
        /**
         * Days
         * How far back to look
         * @min 1
         * @max 365
         * @default 30
         */
        days?: number;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ThresholdBreach[], HTTPValidationError>({
        path: `/doctor/threshold-breaches`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  doctors = {
    /**
     * @description Retrieve a paginated list of doctors with support for both free-text search and advanced JSON:API filters. You can combine both search queries and filters to narrow down results. **Free-text search:** - Use 'query' parameter (min 3 chars) to search by name, email, phone, license number, or specialization **Advanced filters:** - Use JSON:API filter syntax: filter[field]=value - Supports complex filters with OR/AND logic **Pagination:** - /doctors?page[offset]=0&page[limit]=10 - /doctors?page[number]=1&page[size]=10 **Sorting:** - /doctors?sort=-last_name,first_name - Prefix with '-' for descending order **Combined example:** - /doctors?query=smith&filter[specialization]=Cardiology&sort=-created_at
     *
     * @tags Doctors
     * @name ListDoctors
     * @summary Get doctors with search and advanced filtering
     * @request GET:/doctors
     * @secure
     */
    listDoctors: (
      query?: {
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "doctor_id"
         */
        sort?: string | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DoctorGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/doctors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Register a new doctor in the system.
     *
     * @tags Doctors
     * @name CreateDoctor
     * @summary Create a new doctor
     * @request POST:/doctors
     * @secure
     */
    createDoctor: (data: DoctorCreate, params: RequestParams = {}) =>
      this.request<Doctor, void | HTTPValidationError>({
        path: `/doctors`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve details for a single doctor by their ID.
     *
     * @tags Doctors
     * @name GetDoctorById
     * @summary Get doctor by ID
     * @request GET:/doctors/{doctor_id}
     * @secure
     */
    getDoctorById: (doctorId: number, params: RequestParams = {}) =>
      this.request<Doctor, void | HTTPValidationError>({
        path: `/doctors/${doctorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing doctor's information.
     *
     * @tags Doctors
     * @name UpdateExistingDoctorDoctorsDoctorIdPut
     * @summary Update doctor information
     * @request PUT:/doctors/{doctor_id}
     * @secure
     */
    updateExistingDoctorDoctorsDoctorIdPut: (doctorId: number, data: DoctorUpdate, params: RequestParams = {}) =>
      this.request<Doctor, void | HTTPValidationError>({
        path: `/doctors/${doctorId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a doctor from the system.
     *
     * @tags Doctors
     * @name DeleteDoctor
     * @summary Delete doctor
     * @request DELETE:/doctors/{doctor_id}
     * @secure
     */
    deleteDoctor: (doctorId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/doctors/${doctorId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  byUser = {
    /**
     * @description Retrieve a doctor by their user ID
     *
     * @tags Doctors
     * @name GetDoctorByUserId
     * @summary Get doctor by user ID
     * @request GET:/by-user/{user_id}
     * @secure
     */
    getDoctorByUserId: (userId: number, params: RequestParams = {}) =>
      this.request<Doctor, void | HTTPValidationError>({
        path: `/by-user/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
